module.exports = function() { return __webpack_public_path__ + "complete-page-bg.2s78NZe4Ad5hUPi0ukj9.png";};